import { Component, EventEmitter, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoadingService, AlertService } from 'ngx-kuv-tools';
import { ConfigService } from 'src/app/utils/config/config.service';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { ModalDeleteComponent } from 'src/app/utils/modal-delete/modal-delete.component';
import { SesionService } from 'src/app/utils/sesion/sesion.service';
import { VehiculoCreateComponent } from '../vehiculo-create/vehiculo-create.component';
import { VehiculoHistoricoComponent } from '../vehiculo-historico/vehiculo-historico.component';
import { VehiculoUpdateComponent } from '../vehiculo-update/vehiculo-update.component';
import { VehiculoViewComponent } from '../vehiculo-view/vehiculo-view.component';
import { VehiculoService } from '../vehiculo.service';

@Component({
  selector: 'app-vehiculo-index',
  templateUrl: './vehiculo-index.component.html',
  styleUrls: ['./vehiculo-index.component.scss']
})
export class VehiculoIndexComponent implements OnInit {

  url: string = '';
  excel: string = '';

  reloadEmitter: EventEmitter<string> = new EventEmitter();

  filtros = [
    {
      label: 'Desde',
      column: 'fecha_registro',
      op: 'gte',
      type: 'date'
    },
    {
      label: 'Hasta',
      column: 'fecha_registro',
      op: 'lte',
      type: 'date'
    },
    {
      label: 'Patente',
      column: 'patente',
      op: 'like',
    },
    {
      label: 'Marca',
      column: 'marca',
      op: 'like',
    },
    {
      label: 'Modelo',
      column: 'modelo',
      op: 'like',
    },
    {
      label: 'Año',
      column: 'year',
      op: 'like',
    },
  ]

  acciones = [
    {
      label: 'Ver',
      icon: 'eye',
      action: (element: any, index: number) => {
        this.view(element)
      }
    },
    {
      icon: "clipboard-list",
      label: "Revisiones",
      action: (element: any, index: number) => {
        this.showHistory(element);
      },
    },
    {
      label: 'Editar',
      icon: 'pen',
      action: (element: any, index: number) => {
        this.edit(element)
      }
    },
    {
      icon: "toggle-on",
      label: "Activar",
      action: (element: any, index: number) => {
        this.toggle(element);
      },
      hide: (element: any, index: number) => {
        return element.estado == 0;
      }
    },
    {
      icon: "toggle-off",
      label: "Desactivar",
      action: (element: any, index: number) => {
        this.toggle(element);
      },
      hide: (element: any, index: number) => {
        return element.estado == 1;
      }
    },
    {
      icon: "trash",
      label: "Eliminar",
      action: (element: any, index: number) => {
        this.delete(element);
      },
      hide: (element: any, index: number) => {
      }
    }
  ]

  columnas = [
    {
      label: 'Fecha',
      attribute: 'fecha_registro',
      width: 1,
      responsive: ['SM'],
      value: (element: any, index: number) => {
        if (!element.fecha_registro) return '';
        return this.formatter.dateFormat(element.fecha_registro);
      }
    },
    {
      label: 'Patente',
      attribute: 'patente',
      width: 1,
      responsive: ['XS', 'SM', 'MD'],
      value: (element: any, index: number) => {
        if (!element.patente) return '';
        return element.patente;
      }
    },
    {
      label: 'Marca',
      attribute: 'marca',
      width: 1,
      responsive: ['SM', 'MD'],
      value: (element: any, index: number) => {
        if (!element.marca) return '';
        return element.marca;
      }
    },
    {
      label: 'Modelo',
      attribute: 'modelo',
      width: 1,
      responsive: ['MD'],
      value: (element: any, index: number) => {
        if (!element.modelo) return '';
        return element.modelo;
      }
    },
    {
      label: 'Año',
      attribute: 'year',
      width: 1,
      responsive: ['MD'],
      value: (element: any, index: number) => {
        if (!element.year) return '';
        return element.year.toString();
      }
    },
    {
      label: 'Dueño',
      attribute: 'nombre',
      width: 1,
      responsive: ['MD'],
      value: (element: any, index: number) => {
        return this.formatter.nombreCompleto(element.usuario);
      }
    },
  ]

  constructor(
    private config: ConfigService,
    private modalService: NgbModal,
    public loading: LoadingService,
    private alerts: AlertService,
    public service: VehiculoService,
    public sesion: SesionService,
    public formatter: FormatterService
  ) { }

  ngOnInit(): void {
    this.url = this.config.apiUrl + this.service.controller + 'ver';
    this.excel = this.config.apiUrl + this.service.controller + 'excel';
  }

  add(): void {
    const modalRef = this.modalService.open(VehiculoCreateComponent, { windowClass: 'clear-modal', size: 'xl', scrollable: true, backdrop: 'static' });
    modalRef.result.then((result: any) => {
      this.loadData();
    }, (reason: any) => { });
  }

  view(element: any): void {
    const modalRef = this.modalService.open(VehiculoViewComponent, { windowClass: 'clear-modal', size: 'xl', scrollable: true });
    modalRef.componentInstance.element = element;
    modalRef.result.then((result: any) => {
      this.loadData();
    }, (reason: any) => { });
  }

  edit(element: any): void {
    const modalRef = this.modalService.open(VehiculoUpdateComponent, { windowClass: 'clear-modal', size: 'xl', scrollable: true, backdrop: 'static' });
    modalRef.componentInstance.element = element;
    modalRef.result.then((result: any) => {
      this.loadData();
    }, (reason: any) => { });
  }

  toggle(element: any): void {
    if (element.estado == 0) {
      this.loading.show();
      this.service.activate(element.id).subscribe({
        next: (res: any) => {
          this.loading.hide();
          this.loadData();
          this.alerts.addAlert("Se ha activado el Vehículo.", "success");
        },
        error: (err: any) => {
          console.error(err);
          this.loading.hide();
          this.alerts.addAlert("No se ha podido activar el registro.", "danger");
        }
      });
      return;
    }
    if (element.estado == 1) {
      this.loading.show();
      this.service.deactivate(element.id).subscribe({
        next: (res: any) => {
          this.loading.hide();
          this.loadData();
          this.alerts.addAlert("Se ha desactivado el Vehículo.", "success");
        },
        error: (err: any) => {
          console.error(err);
          this.loading.hide();
          this.alerts.addAlert("No se ha podido desactivar el registro.", "danger");
        }
      });
    }
  }

  delete(element: any): void {
    const modalRef = this.modalService.open(ModalDeleteComponent, { windowClass: 'clear-modal', size: 'md', scrollable: true, backdrop: 'static' });
    modalRef.componentInstance.titulo = 'Eliminar Vehículo';
    modalRef.componentInstance.texto = '¿Seguro que desea eliminar este registro?';
    modalRef.componentInstance.textoAceptar = 'Eliminar';
    modalRef.result.then((result) => {
      this.loading.show();
      this.service.delete(element.id).subscribe({
        next: (res: any) => {
          this.loading.hide();
          this.loadData();
          this.alerts.addAlert("Vehículo eliminado con éxito.", "success");
        },
        error: (err: any) => {
          console.error(err);
          this.loading.hide();
          this.alerts.addAlert("No se ha podido eliminar el registro del vehículo.", "danger");
        }
      });
    }, (reason) => { });
  }

  showHistory(element: any): void {
    const modalRef = this.modalService.open(VehiculoHistoricoComponent, { windowClass: 'clear-modal', size: 'xl', scrollable: true });
    modalRef.componentInstance.element = element;
    modalRef.result.then((result: any) => {
      this.loadData();
    }, (reason: any) => { });
  }

  loadData(): void {
    this.reloadEmitter.emit();
  }
}
